import React from 'react';
import { Form, Input } from 'antd';

import ColorPicker from 'components/color-picker';

import GenericForm, { Props as GenericFormProps } from 'routes/generic/form';

type Props = Omit<GenericFormProps, 'renderFields'>;

const EditForm: React.FC<Props> = props => {
  return (
    <GenericForm
      {...props}
      renderFields={({ fields }) => (
        <>
          <Form.Item label="Scope" name="scope">
            <Input className="monospace" />
          </Form.Item>
          <Form.Item required label="Value" name="value">
            <Input className="monospace" />
          </Form.Item>
          <Form.Item required label="Color" name="color">
            <ColorPicker />
          </Form.Item>
        </>
      )}
    />
  );
};

export default EditForm;
